import React, { useCallback, ReactNode } from "react"
import { Button } from "@chakra-ui/react"
import { Transaction } from "container/transaction"

interface TxButtonProps {
    onClick: Function
    disabled?: boolean
    children: ReactNode
    colorScheme?: string
}

export function TxButton({ onClick, disabled, children, ...rest }: TxButtonProps) {
    const { isLoading } = Transaction.useContainer()
    const handleClick = useCallback(() => {
        if (onClick) {
            onClick()
        }
    }, [onClick])

    return (
        <Button
            onClick={handleClick}
            isFullWidth
            isLoading={isLoading}
            disabled={disabled || isLoading}
            colorScheme="perpetual"
            {...rest}
        >
            {children}
        </Button>
    )
}
